import { render } from "./SafetySectionComponent.vue?vue&type=template&id=7b2d484e&scoped=true"
import script from "./SafetySectionComponent.vue?vue&type=script&lang=js"
export * from "./SafetySectionComponent.vue?vue&type=script&lang=js"

import "./SafetySectionComponent.vue?vue&type=style&index=0&id=7b2d484e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b2d484e"]])

export default __exports__